"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Pager_native_exports = {};
__export(Pager_native_exports, {
  Page: () => Page,
  Pager: () => Pager
});
module.exports = __toCommonJS(Pager_native_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_controlled = require("./controlled");
var import_react = require("react");
var import_OneNativeTabNativeComponent = __toESM(require("./specs/OneNativeTabNativeComponent"), 1);
var import_OneNativeSwiftPagerNativeComponent = __toESM(require("./specs/OneNativeSwiftPagerNativeComponent"), 1);
var import_viewportStyle = require("./viewportStyle");
var PAGE_STYLE = {
  position: "absolute",
  left: 0,
  top: 0,
  width: "100%",
  height: "100%"
};
function Page(_props) {
  throw new Error("Swift.Page must be a direct child of Swift.Pager");
}
function Pager(param) {
  var { children, selection, onSelectionChange, revision = 0, style, ...props } = param;
  var controlled = (0, import_controlled.useControlled)(function(event) {
    return onSelectionChange(event.selection);
  }, revision);
  var pages = (0, import_react.useMemo)(function() {
    var ids = /* @__PURE__ */ new Set();
    return import_react.Children.toArray(children).map(function(child) {
      if (!/* @__PURE__ */ (0, import_react.isValidElement)(child) || child.type !== Page) {
        throw new Error("Swift.Pager accepts Swift.Page elements as direct children");
      }
      var { id, testID, children: page } = child.props;
      if (!id || ids.has(id)) {
        throw new Error(`Swift.Pager requires unique, nonempty page ids: "${id}"`);
      }
      ids.add(id);
      return {
        id,
        testID,
        children: page
      };
    });
  }, [
    children
  ]);
  var selected = pages.find(function(page) {
    return page.id === selection;
  });
  if (!selected) {
    throw new Error(`Swift.Pager selection "${selection}" must identify a mounted Swift.Page`);
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_OneNativeSwiftPagerNativeComponent.default, {
    ...props,
    style: (0, import_viewportStyle.viewportStyle)(style),
    selection,
    acknowledgedEvent: controlled.acknowledgedEvent,
    revision,
    onNativePagerSelectionChange: function onNativePagerSelectionChange(param2) {
      var { nativeEvent } = param2;
      return controlled.onNativeChange(nativeEvent);
    },
    children: pages.map(function(page) {
      var visible = page.id === selection;
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_OneNativeTabNativeComponent.default, {
        tabId: page.id,
        title: "",
        systemImage: "",
        badge: "",
        tabRole: "",
        kind: "page",
        slotHeight: 0,
        tabModifiers: "{}",
        testID: page.testID,
        style: PAGE_STYLE,
        collapsable: false,
        pointerEvents: visible ? "auto" : "none",
        accessibilityElementsHidden: !visible,
        importantForAccessibility: visible ? "auto" : "no-hide-descendants",
        children: page.children
      }, page.id);
    })
  });
}
//# sourceMappingURL=Pager.native.js.map
